import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
const selectFeatureSearchContext = (state) => state.experimentSearchModule.featureSearchV4.context;
const selectUserAffinity = (state) => state.currentUserDetails.userAffinity;
const selectExperimentationGroupsAsync = (state, workspaceId) => {
  var _a;
  return (_a = state.experimentSearchModule.featureSearchV3.experimentationGroups[workspaceId]) != null ? _a : getDefaultAsyncWrapperObj();
};
export {
  selectExperimentationGroupsAsync,
  selectFeatureSearchContext,
  selectUserAffinity
};
//# sourceMappingURL=selectors.js.map
